export default __webpack_public_path__ + "static/out_sourcing1-6bbd504f2137c3702bc137340835170a.jpg";